'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var ComponentLoader = require('../alloy-loader/ComponentLoader/ComponentLoader.js');
var modal_module = require('./modal.module.scss.js');

var ModalLoader = function (_a) {
    var modalRef = _a.modalRef;
    var _b = react.useState({
        top: '0px',
        bottom: '0px'
    }), loaderPositioning = _b[0], setLoaderPositioning = _b[1];
    //Get scrollPosition to  position the Loader accordingly
    var scrollTop = (modalRef.current !== null ? modalRef.current : { scrollTop: 0 }).scrollTop;
    react.useEffect(function () {
        var closeButtonHeight = 40;
        // If user scrolled down but close button is still visible then loader should let the user click it
        if (scrollTop > 0 && scrollTop < closeButtonHeight) {
            setLoaderPositioning({
                top: '0px',
                bottom: "-".concat(scrollTop, "px")
            });
            // If user scrolled down and close button is not visible then loader should fill all the modal
        }
        else if (scrollTop >= closeButtonHeight) {
            setLoaderPositioning({
                top: "".concat(scrollTop, "px"),
                bottom: "-".concat(scrollTop, "px"),
                marginTop: '0px'
            });
        }
    }, [scrollTop]);
    return (jsxRuntime.jsx("div", tslib.__assign({ className: modal_module.default['modal__loader'], style: loaderPositioning, "data-testid": "loaderContainer" }, { children: jsxRuntime.jsx(ComponentLoader.default, {}) })));
};
var ModalLoader$1 = ModalLoader;

exports.default = ModalLoader$1;
//# sourceMappingURL=ModalLoader.js.map
